import { api } from "./api";


export const testAdd = async (data) => {
    return await api.post(`test/v2/add`, data)
}
export const getTestDetails = async (id) => {
    return await api.get(`test/v2/details/${id}`)
}
export const testUpdate = async (data) => {
    return await api.post('test/v2/update', data)
}


export const obtendMarks = async (data) => {
    return await api.post(`/test/v2/marks/post`, data)
}

export const marksExcelUpload = async (data) => {
    return await api.post(`/test/v2/marks/excel/upload`, data)
}

export const testLock = async (id) => {
    return await api.post(`test/v2/locked?id=${id}`)
}

export const fetchCard = async (addUrl = '') => {
    let url = `/test/v2/admin/card/details?${addUrl}`
    return await api.get(url)
}

export const testList = async (addUrl = '') => {
    let url = `/test/v2/list?${addUrl}`
    return await api.get(url)
}
export const fetchAnnualExcel = async (addUrl = '') => {
    let url = `/test/v2/student/details/test?${addUrl}`
    return await api.get(url)
}

export const removeTestSubjects = async (data) => {
    return await api.post(`/test/v2/remove-subjects`, data);
};